import React, { useEffect, useInsertionEffect, useState } from 'react'
import { Form } from 'antd'

import ImageUrl from './ImageUrl';
import { RecaptchaVerifier } from 'firebase/auth';


const BannerForm = (props) => {
    const { banner, callback } = props;
    const [lines, setLines] = useState([]);
    const [pai, setPai] = useState(banner);
    useEffect(() => {
        let pretty = [];
        pretty.push(<ImageUrl imgsrc={banner.imageUrl_ca} urllnk={banner.url_ca} sufix='ca' key='imgUrl_1' callback={handleCallback}/>)
        pretty.push(<ImageUrl imgsrc={banner.imageUrl_es} urllnk={banner.url_es} sufix='es' key='imgUrl_2' callback={handleCallback} />)
        pretty.push(<ImageUrl imgsrc={banner.imageUrl_en} urllnk={banner.url_en} sufix='en' key='imgUrl_3' callback={handleCallback} />)
        pretty.push(<ImageUrl imgsrc={banner.imageUrl_fr} urllnk={banner.url_fr} sufix='fr' key='imgUrl_4' callback={handleCallback} />)
        setLines(pretty);
    }, [props]);
    
    const handleCallback = (f, url, sfx) => {
//console.log('handleCallback: ', f, url, sfx);
        let repai = {...pai};
        if(f) { 
            if(!repai.f) repai.f= {}
            repai.f[sfx] = f; 
        }
        if(url) { 
            repai[`url_${sfx}`] = url} 
        //props.callback(repai);
        setPai(repai);
    }
    
    useEffect(() => {
        callback(pai);
    }, [pai])

    const [form] = Form.useForm();  
    const onFinish = (values) => {
//console.log('Received values of form: ', values);
    }

    return(
        <React.Fragment>
            <Form
                    form={form}
                    name="register"
                    onFinish={onFinish}
                    scrollToFirstError
                    >
                    {lines}
                </Form>

        </React.Fragment>
    )
}

export default BannerForm;